module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regionalTeamDetail"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("服务人员简介")]), _vm._v(" "), _c('img', {
    staticClass: "bgImg",
    attrs: {
      "src": _vm.bgImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "sculpture",
    attrs: {
      "src": _vm.listItem.tx
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.listItem.title))]), _vm._v(" "), _c('p', [_vm._v("电话："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": 'tel:' + _vm.listItem.tel
    }
  }, [_vm._v(_vm._s(_vm.listItem.tel))])]), _vm._v(" "), _c('p', [_vm._v("服务区域：" + _vm._s(_vm.listItem.regional))])]), _vm._v(" "), _c('p', [_vm._v("服务内容：" + _vm._s(_vm.listItem.dection))]), _vm._v(" "), _c('p', [_vm._v("合作医院："), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.listItem.hosipital)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wechatImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.listItem.src
    }
  }), _vm._v(" "), _c('p', [_vm._v("长按加微信")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c9c42c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/regionalServiceProject/regionalTeamDetail.vue
// module id = TfSF
// module chunks = 7